// Module
var code = `<p class=""> <label translate>{{\$ctrl.label}}</label> <span class="block mt-1 text-sm">{{\$ctrl.content}}</span> </p>`;
// Exports
export default code;